import { render, staticRenderFns } from "./azenc-video-player.vue?vue&type=template&id=4a8fdd0a&scoped=true&"
import script from "./azenc-video-player.vue?vue&type=script&lang=js&"
export * from "./azenc-video-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fdd0a",
  null
  
)

export default component.exports